import type { PlayerTrackerConfig } from '../../playerTracker.types.ts';

const PLAYER_TRACKER: PlayerTrackerConfig = {
  impressions: {
    deposit_limit_set_confirmation: 'deposit_limit_set_confirmation',
    deposit_limit_annual_reminder: 'deposit_limit_annual_reminder',
    login_error_self_exclusion: 'login_error_self_exclusion',
    activity_statement_report_balance_page_popup: 'activity_statement_report_balance_page_popup',
    big_win_stake_block: 'big_win_stake_block',
    payment_internal_weekly_limit: 'payment_internal_weekly_limit',
    payment_look_back_limit: 'payment_look_back_limit',
    extended_play_pop_up: 'extended_play_pop_up',
  },
};

export { PLAYER_TRACKER };
